export enum RequestMethod {
    GET = 'GET' , 
    POST = "POST", 
    PUT = "PUT" , 
    DELETE = "DELETE" 
}
export type requestMethods = RequestMethod.GET | RequestMethod.POST | RequestMethod.PUT | RequestMethod.DELETE;
